import { Get, Post, downFilePost } from '@/utils/axios'

/**
POST
/app/Goods/GetPublicGoods
获取公有商品
 */
export function getPagePublicGoods(param) {
  return Post('/Goods/GetPublicGoods', param)
}

/**
GET
/app/Goods/GetPublicGoods/{Id}
获取公有商品详情
 */
export function getPublicGoods(Id) {
  return Get(`/Goods/GetPublicGoods/${Id}`)
}

/**
POST
/app/Goods/GetPrivateGoods
获取私有商品
 */
export function getPagePrivateGoods(param) {
  return Post('/Goods/GetPrivateGoods', param)
}

/**
GET
/app/Goods/GetPrivateGoods/{Id}
获取私有商品
 */
export function getPrivateGoods(Id) {
  return Get(`/Goods/GetPrivateGoods/${Id}`)
}

/*  */
export function GetPrivateProductList(data) {
  return Post('/Goods/GetPrivateProductList', data)
}

/**
 * 更新安全库存
 * @param {*} data
 * @returns
 */
export function updateSafetyStock(data) {
  return Post('/Goods/UpdateSafetyStock', data)
}

/**
 * 批量修改安全库存
 * @param {*} data
 * @returns
 */
export function batchUpdateSafetyStock(data) {
  return Post('/Goods/BatchUpdateSafetyStock', data)
}

/*
  获取报价商品
 */
export function GetQuotedProducts(data) {
  return Post('/Goods/GetQuotedProducts', data)
}

/**
POST
/app/Goods/GetStoreGoods
获取店铺商品信息
 */
export function getPageStoreGoods(param) {
  return Post('/Goods/GetStoreGoods', param)
}

/**
GET
/app/Goods/GetStoreGoods/{Id}
获取公有商品详情
 */
export function getStoreGoods(Id) {
  return Get(`/Goods/GetStoreGoods/${Id}`)
}

/**
POST
私有商品推送到店铺
 */
export function goodsToStoreGoods(param) {
  return Post('/Goods/GoodsToStoreGoods', param)
}

/**
GET
店铺商品详情
 */
export function getStoreGood(id) {
  return Get(`/Goods/GetStoreGoods/${id}`)
}

/**
POST
修改店铺商品信息
 */
export function updateMyGoodsContent(data) {
  return Post('/Goods/UpdateMyGoodsContent', data)
}

/**
POST
修改店铺商品sku推送状态
 */
export function updateGoodsProductPushStatus(data) {
  return Post('/Goods/UpdateGoodsProductPushStatus', data)
}

/**
POST
图片不上传
 */
export function updateGoodsNoUploadImage(data) {
  return Post('/Goods/UpdateGoodsNoUploadImage', data)
}

/**
POST
删除商品
 */
export function deleteGoodsPorduct(id) {
  return Post('/Goods/DeleteGoodsPorduct', { id })
}

/**
POST
修改店铺sku价格
 */
export function updateStoreProductPrice(data) {
  return Post('/Goods/UpdateStoreProductPrice', data)
}
/**
POST
查询运输方式列表
 */
export function getTransportType(data) {
  return Post('/Goods/GetTransportType', data)
}

/**
POST
/app/Goods/GetStoreGoodsList
获取店铺商品列表
 */
export function GetStoreGoodsList(param) {
  return Post('/Goods/GetStoreGoodsList', param)
}
/**
 * 店铺商品详情
 */
export function GetStoreDetailList(data) {
  return Get(`/Goods/GetStoreDetailList`, data)
}
/**
POST
/app/Goods/GetStoreListExport
店铺商品导出
 */
export async function GetStoreListExport(param) {
  await downFilePost('/Goods/GetStoreListExport', { ...param })
}
export async function PrivateGoodsExport(param) {
  await downFilePost('/Goods/PrivateGoodsExport', { ...param })
}
// 推送
export function PublishGoodsStock(param) {
  return Post('/Goods/PublishStock', param)
}
// 获取商品服务类型
export function GetGoodsServiceTypes() {
  return Get(`/Goods/GetGoodsServiceTypes`)
}
// 获取商品服务列表
export function GetGoodsServicesList(param) {
  return Post('/Goods/GetGoodsServices', param)
}
// 获取商品服务信息
export function GetGoodsServices(Id) {
  return Get(`/Goods/GetGoodsServices/${Id}`)
}
// 服务确认
export function ServiceConfirm(param) {
  return Post('/Goods/ServiceConfirm', param)
}
// 服务批量确认
export function BatchServiceConfirm(param) {
  return Post('/Goods/BatchServiceConfirm', param)
}
// 批量设置警戒值
export function SetAlarmStock(param) {
  return Post('/Goods/SetAlarmStock', param)
}
// 设置了警戒值的产品
export function GetAlarmStock(param) {
  return Post('/Goods/GetAlarmStock', param)
}
// 修改产品名称
export function UpdateGoodsSubjectEn(param) {
  return Post('/Goods/UpdateGoodsSubjectEn', param)
}
// 选中产品
export function SelectdGoods(param) {
  return Post('/Goods/SelectdGoods', param)
}
// 辅料列表
export function GetAccessories(param) {
  return Post('/StoreGoods/GetAccessories', param)
}
// 获取包装列表
export function GetPackingsListNew(param) {
    return Post('/StoreGoods/GetPackingsListNew', param)
}
// 查询店铺商品配对状态及价格
export function GetProductPairStatus(ids) {
  return Post('/StoreGoods/GetProductPairStatus', { ids })
}
// 保存店铺商品WEEE凭证
export function SaveProductWeee(data) {
  return Post('/StoreGoods/SaveProductWeee', data)
}